








import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Survey = () => import(/* webpackChunkName: "survey" */ '@/components/survey/Survey.vue');

import { SnowplowContext } from '@/helpers/tracking/providers';

import { SurveyObject } from '@/interfaces/responses/survey';

const Language = namespace('language');
const Pull = namespace('pull');

@Component({
	name: 'LoadSurvey',
	components: {
		Survey,
	},
})
export default class LoadSurvey extends Vue {
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];
	@Prop({ default: true }) isTimelineSurvey: boolean;

	@Language.Getter locale: string;

	@Pull.Getter survey: SurveyObject;

	isShown = false;

	created() {
		this.onSurveyChanged();
	}

	// sometimes the survey is not ready when the site gets rendered
	@Watch('survey')
	onSurveyChanged() {
		this.isShown = false;
		if (this.survey?.start_question_node_id) {
			this.isShown = true;
		}
	}

	get showSurvey(): boolean {
		return !!(this.survey && this.isShown);
	}
}
